import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import API from '../../utils/api/API';
import Button from '../../elements/Button';
import Popup from '../Popup';
import { useClosePopup } from '../../utils/hooks/usePopup';
import Objects from '../../utils/api/Objects';
import Auctions from '../../utils/api/Auctions';

export default function DeleteAuction({ id }) {
	const [auction, setAuction] = useState();
	let history = useHistory();

	const close = useClosePopup();

	const deleteAuction = async () => {
		await Auctions.delete(id);
		API.clearCache(`_/auctions_`);
		history.go(0);
		close();
	};

	useEffect(() => {
		(async () => {
			setAuction(await Auctions.get(id));
		})();
	}, [id]);

	return (
		<Popup close={close} width="40em" maxWidth="25em">
			<Style>
				<h2 className="title">
					Ta bort auktion nummer <strong>{id}</strong>?
				</h2>
				<div className="spacer s"></div>
				<p>
					Vill du verkligen ta bort <strong>"{auction?.name}"</strong>. Alla objekt som hör till auktionen kommer att avpubliceras och tas bort från auktionen. Åtgärden är permanent och kan ej ångras!
				</p>

				<div className="buttons">
					<Button type="secondary" onClick={close}>
						Nej
					</Button>
					<Button onClick={deleteAuction}>Ja</Button>
				</div>
			</Style>
		</Popup>
	);
}

const Style = styled.div``;
